interface TabGroupMapping {
  [key: string]: {
    [key: string]: string[];
  };
}

// Define for each library name the 1:m relation for tab <-> allowed groups.
export const tabGroupMapping: TabGroupMapping = 
{
  "libjobcontact":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellheaderplatform":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libjobprogramphasecode1":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellattributes1":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellattributes2":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellattributes3":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellheaderarea":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellheaderfield":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellheaderccn":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellheaderlease":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellheaderplantcode":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libwellheaderusertxt3":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  },
  "libstimusertxt1":{
    "Asia South": ["Wellview TBU Admin"],
    "Australasia": ["WellView ABU Champions","RigView_Champion_Global"],
    "Canada": ["WellView CBU Champion"],
    "CWDE": ["WellView CTC Geothermal Champions","WellView CTC PA Champions","WellView CTC OPG Champions","WellView CTC CCUS Champions"],
    "EMC": ["WellView EMC Champion"],
    "Eastern Mediterranean": ["WellView EMED Champion"],
    "Eurasia": [],
    "Europe": [],
    "Gulf of Mexico": ["WellView GOM Champion"],
    "IndoAsia": [],
    "JO / PNZ": ["JOP - WellView Admins"], // create AD group WellView JO/PNZ Champion
    "Latin America": ["WellView LABU ARG Champion", "WellView LABU BRZ CHAMPIONS", "WellView LABU COL Champion", "WellView LABU vott Champion"],
    "Mid-Continent": ["WellView MCBU Champion"],
    "Nigeria/Mid-Africa": ["Wellview NMA Champions"],
    "Rockies": ["WellView RBU Champion"],
    "San Joaquin Valley": ["WellView SJV Champion"],
    "Southern Africa": ["WellView SASBU Champion"]
  }
}
